import {useQuery} from '@tanstack/react-query'
import {sanityClient} from '@/lib/sanity'
import {ALL_AUTHORS_QUERY} from '@/lib/sanityQueries'
import type {AuthorSummary} from '@/types/author'

export const useAuthors = () =>
  useQuery({
    queryKey: ['authors', 'all'],
    queryFn: () => sanityClient.fetch<AuthorSummary[]>(ALL_AUTHORS_QUERY),
  })
